import { React, useState,useEffect } from "react";
import "./index.css";
import axios from 'axios'
import 'bootstrap/dist/css/bootstrap.min.css';
import Button from 'react-bootstrap/Button';
import image from  "./img/switch.png";
import logoutimg from "./img/logout.png";
import imagebk from  "./img/back.png";
import remove from  "./img/remove.png";
import Select from "react-dropdown-select";
import {GET_SWITCHEMPDATA,POSTFILES,PANFILES,NDAFILES,CTCFILES,OFFERFILES,VENDOR_MASTER_INSERT_USER} from '../AppConstant'

function Landing() {
    const [employee_name, setEmployee_name] = useState("");
    const [dob, setDob] = useState("");
    const [emergencynumber,setEmergencynumber]= useState("");
    const [blood,setBlood]= useState("");
    const [persexp,setPersexp]= useState("");
    const [aadharcard,setAadharcard]= useState("");
    const [pan,setPan]= useState("");
    const [address,setAddress]= useState("");
    const [dataUri, setDataUri] = useState('')
    const [rawdatafile,setRawdatafile]= useState('')
    const [panfile,setPanfile]= useState('')
    const [issecondtab,setIssecondtab]=useState(false);
    const [searchdata,setSearchdata]=useState([]);
    const [employee_sec_name,setEmployee_sec_name] = useState('')
    const [officialid,setOfficialid]= useState('');
    const [companyempid,setCompanyempid]= useState('');
    const [empswcode,setEmpswcode]= useState('');
    const [ndafile,setNdafile]= useState('');
    const [ctcfile,setCtcfile]= useState('');
    const [offerfile,setOfferfile]= useState('');
    const [switch_code_val,setSwitch_code_val]= useState('');
    const [opensuccess,setOpensuccess]= useState(false);
    const [successmessage,setSuccessmessage]=useState("");
    const [useremailids,setUseremailids]=useState("");
    const [monthlygrossdata,setMonthlygrossdata]=useState("");

    const redirectTodashboard = ()=>{
        window.location.href = "/landingPage"
    }
    const redirectToLogin = ()=>{
        window.location.href = "/login"
    }
    
    useEffect(()=>{calluserinfofn()},[])

    const calluserinfofn=()=>{
        setSwitch_code_val(localStorage.getItem('empid'))
        axios({
            method: "get",
            url: GET_SWITCHEMPDATA,
            withCredentials: false,
            headers: {
              "Content-Type": "application/x-www-form-urlencoded",
              "Access-Control-Allow-Origin": "*",
            },
            params: { switchcode: localStorage.getItem('empid') },
            // params: { switchcode: localStorage.getItem('empid'); },
          })
            .then((response) => {
                console.log(response.data.data[0])
                setEmpswcode(response.data.data[0].switch_code)
                setEmployee_name(response.data.data[0].employee_name)
                setEmployee_sec_name(response.data.data[0].employee_sec_name)
                setUseremailids(response.data.data[0].hremailid)
            })
            .catch((error) => {
              console.error(error);
            });
    }
    
   const filechangefn=(file,d)=>{
    // setRawdatafile(file)
    if(file.type === "application/pdf"){
        if(file.size <= 5000000){
    const formData = new FormData();
    formData.append('type', "Adhar_docs");
    formData.append('ID', empswcode);
    formData.append('file',file)
    console.log(formData)
    setRawdatafile(formData)
    // if(!file) {
    //     setDataUri('');
    //     return;
    //   }
  
    //   fileToDataUri(file)
    //     .then(dataUri => {
    //       setDataUri(dataUri)
    //     })
    }else{
        document.getElementById(d).value = "";
        alert("Upload Size not greater than 5 MB")
    }
    }else{
    document.getElementById(d).value = "";
    alert("Please Upload only PDF format")
    }
   } 
   const filechangepanfn=(file,d)=>{
    // setRawdatafile(file)
    if(file.type === "application/pdf"){
        if(file.size <= 5000000){
    const formData = new FormData();
    formData.append('type', "Pan_docs");
    formData.append('ID', empswcode);
    formData.append('file',file)
    console.log(formData)
    setPanfile(formData)
    }else{
        document.getElementById(d).value = "";
        alert("Upload Size not greater than 5 MB")
    }
    }else{
    document.getElementById(d).value = "";
    alert("Please Upload only PDF format")
    }
   } 
//    const filechangegrossfn=(file,d)=>{
//     console.log(file)
//     // setRawdatafile(file)
//     if(file.type === "application/pdf"){
//         if(file.size <= 5000000){
//             const formData = new FormData();
//         formData.append('type', "Gross_docs");
//         formData.append('ID', empswcode);
//         formData.append('file',file)
//         console.log(formData)
//         setGrossfile(formData)
        
//         }else{
//             document.getElementById(d).value = "";
//             alert("Upload Size not greater than 5 MB")
//         }
//         }else{
//         document.getElementById(d).value = "";
//         alert("Please Upload only PDF format")
//     }
//    }

   const filechangeofferfn=(file,d)=>{
    console.log(file)
    // setRawdatafile(file)
    if(file.type === "application/pdf"){
        if(file.size <= 5000000){
            const formData = new FormData();
        formData.append('type', "Offers_docs");
        formData.append('ID', empswcode);
        formData.append('file',file)
        console.log(formData)
        setOfferfile(formData)
        
        }else{
            document.getElementById(d).value = "";
            alert("Upload Size not greater than 5 MB")
        }
        }else{
        document.getElementById(d).value = "";
        alert("Please Upload only PDF format")
    }
   }
   const filechangectcfn=(file,d)=>{
    console.log(file)
    // setRawdatafile(file)
    if(file.type === "application/pdf"){
        if(file.size <= 5000000){
            const formData = new FormData();
        formData.append('type', "Ctc_docs");
        formData.append('ID', empswcode);
        formData.append('file',file)
        console.log(formData)
        setCtcfile(formData)
        
        }else{
            document.getElementById(d).value = "";
            alert("Upload Size not greater than 5 MB")
        }
        }else{
        document.getElementById(d).value = "";
        alert("Please Upload only PDF format")
    }
   }
   const filechangendafn=(file,d)=>{
    console.log(file)
    // setRawdatafile(file)
    if(file.type === "application/pdf"){
        if(file.size <= 5000000){
            const formData = new FormData();
        formData.append('type', "NDA_docs");
        formData.append('ID', empswcode);
        formData.append('file',file)
        console.log(formData)
        setNdafile(formData)
        // if(!file) {
        //     setDataUri('');
        //     return;
        //   }
      
        //   fileToDataUri(file)
        //     .then(dataUri => {
        //       setDataUri(dataUri)
        //     })
        }else{
            document.getElementById(d).value = "";
            alert("Upload Size not greater than 5 MB")
        }
        }else{
        document.getElementById(d).value = "";
        alert("Please Upload only PDF format")
    }
    
   } 
   const fileToDataUri = (file) => new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.onload = (event) => {
      resolve(event.target.result)
    };
    reader.readAsDataURL(file);
    })
    const handleSubmit=(e)=>{
        e.preventDefault();       
        if(!employee_name||!employee_sec_name||!dob||!emergencynumber||!blood||!persexp||!aadharcard||!pan||!address||!rawdatafile||!ndafile||!offerfile||!panfile ||!monthlygrossdata){
            alert("Please fill all the fields")
        }else{
            insertdata();
            
        }
    }
    const insertdata=()=>{
        let switch_code =switch_code_val
        let status="User Acknowledged"
        // let remarks="Mail Sent"
        let hremailid=useremailids

        axios.post(VENDOR_MASTER_INSERT_USER, {switch_code,employee_name,employee_sec_name,dob,address,officialid,emergencynumber,blood,persexp,aadharcard,pan,status,hremailid,monthlygrossdata})
        .then(function (response) {
            setOpensuccess(true)
            setSuccessmessage("Your onboarding details have been submitted successfully. Onboarding team will review your information and get back to you")
        //   handleReset();
        })
        .catch(function (error) {
          console.log(error);
        });
        axios({
            method: 'post',
            url: POSTFILES,
            headers: { "Content-Type": "multipart/form-data" },
            data : rawdatafile

        }).then(response => {
            // alert(response.data);
            
        })  
        .catch(error => {
            console.error(error);
        });
        axios({
            method: 'post',
            url: PANFILES,
            headers: { "Content-Type": "multipart/form-data" },
            data : panfile

        }).then(response => {
            // alert(response.data);
            
        })  
        .catch(error => {
            console.error(error);
        });
        axios({
            method: 'post',
            url: NDAFILES,
            headers: { "Content-Type": "multipart/form-data" },
            data : ndafile

        }).then(response => {
            // alert(response.data);
            
        })  
        .catch(error => {
            console.error(error);
        });
        axios({
            method: 'post',
            url: CTCFILES,
            headers: { "Content-Type": "multipart/form-data" },
            data : ctcfile

        }).then(response => {
            // alert(response.data);
            
        })  
        .catch(error => {
            console.error(error);
        });
        axios({
            method: 'post',
            url: OFFERFILES,
            headers: { "Content-Type": "multipart/form-data" },
            data : offerfile

        }).then(response => {
            // alert(response.data);
            
        })  
        .catch(error => {
            console.error(error);
        });
        // axios({
        //     method: 'post',
        //     url: GROSSFILES,
        //     headers: { "Content-Type": "multipart/form-data" },
        //     data : grossfile

        // }).then(response => {
        //     // alert(response.data);
            
        // })  
        // .catch(error => {
        //     console.error(error);
        // });
    }
    const handleReset=(e)=>{

        // let pdfpath = document.getElementById("myfiles-adhar").value;
        // console.log(pdfpath)
        // const imageData = fs.readFileSync(pdfpath);
//         const form = new FormData();
//         form.append('file', imageData, {
//             filepath: pdfpath,
//             contentType: 'application/pdf',


// });      
            // let sampledrawdata= "vigensh"
            // console.log(rawdatafile)
            // axios.post(POSTFILES, rawdatafile)
            // .then(function (response) {
            // console.log("SuccessFully created");
            // alert(response.data);
            
            // })
            // .catch(function (error) {
            // console.log(error);
            // });
           

    }
    const callclosesuccess=()=>{
        setOpensuccess(false)
     }
    return (
        <div className="bg_set_ven">   
         <div>
                    {/* <img className="switch-back-ven" onClick={redirectTodashboard} src={imagebk}/> */}
                    {/* <img className="switch-img" src={image}/> */}
                    <img className="logout-img-ven" title="Logout" onClick={redirectToLogin} src={logoutimg}/>
                </div><br/><br/>         
             <div>
            </div>
            <div>
        <div>
        {opensuccess===true?<div id="myModal" className="modal-one-docs"> 
                        <div className="closebar">  <span className="close-one-success" onClick={()=>callclosesuccess()}>&times;</span></div>
                            <div className="model-content-success">
                           <p>{successmessage}</p>
                            </div>
                        </div>:''}  
            <div className="Apps-asset">
            <p className="Headings">Personal Information</p>
            <div className="row">
                    
            {/* <div className="col-md-2 tabfour">View Request</div> */}
             </div> 
             {/* <div style={{backgroundImage: "url('ImageLocation')",backgroundSize: "cover",height:"480px", paddingTop:"80px;"}}>
             <img src="ImageFilePath" style={{height:"150px"}}/>
            </div> */}
             <div className="row spacing">
                        <div className="col-md-4">
                        <div className="row">
                        <div className="col-md-6"><label htmlFor="employeename">First Name</label></div>
                        <div className="col-md-6"> 
                        <input
                            type="text"
                            name="employeename"
                            id="employeename"
                            value={employee_name}
                            onChange={(e) =>
                                setEmployee_name(e.target.value)
                            }
                            placeholder="Enter First Name"
                            required
                        />
                        </div>
                        </div>
                       
                        </div>
                        <div className="col-md-4">
                        <div className="row">
                        <div className="col-md-6"><label htmlFor="employeename">Second Name</label></div>
                        <div className="col-md-6"> 
                        <input
                            type="text"
                            name="employeename"
                            id="employeename"
                            value={employee_sec_name}
                            onChange={(e) =>
                                setEmployee_sec_name(e.target.value)
                            }
                            placeholder="Enter Second Name"
                            required
                        />
                        </div>
                        </div>
                        </div>
                        <div className="col-md-4">
                        <div className="row">
                        <div className="col-md-6">
                        <label htmlFor="birthday">DOB</label></div>
                        <div className="col-md-6">
                            <input type="date"  onChange={(e) =>setDob(e.target.value)} id="birthday" name="birthday"/>
                            </div>
                        </div>
                        </div>
                        
                                                  
                             
                        </div>
                        <div className="row spacing">
                        {/* <div className="col-md-4">
                        <div className="row">
                        <div className="col-md-6"><label htmlFor="Company empID">Current Company emp ID  </label></div>
                        <div className="col-md-6"> 
                        <input
                            type="text"
                            name="companyempid"
                            id="companyempid"
                            value={companyempid}
                            onChange={(e) =>
                                setCompanyempid(e.target.value)
                            }
                            placeholder="Enter Current Company Employee ID"
                            required
                        />
                        </div>
                        </div> 
                      
                             </div>  */}
                        <div className="col-md-4">
                        <div className="row">
                        <div className="col-md-6"><label htmlFor="officialid">Official Email ID</label></div>
                        <div className="col-md-6"> 
                        <input
                            type="text"
                            name="officicalid"
                            id="officicalid"
                            value={officialid}
                            onChange={(e) =>
                                setOfficialid(e.target.value)
                            }
                            placeholder="Enter Officical Email ID"
                            required
                        />
                        </div>
                        </div>
                        </div>
                        <div className="col-md-4">
                        <div className="row">
                        <div className="col-md-6">
                        <label htmlFor="birthday">Emergency Contact Number</label></div>
                        <div className="col-md-6">
                        <input
                            type="number"
                            name="emnumber"
                            id="emnumber"
                            maxLength="12"
                            value={emergencynumber}
                            onChange={(e) =>
                                setEmergencynumber(e.target.value)
                            }
                            placeholder="Enter Number"
                            required
                        />
                            </div>
                        </div>
                        </div>
                       
                        <div className="col-md-4">
                        <div className="row">
                        <div className="col-md-6"><label htmlFor="employeename">Blood Group  </label></div>
                        <div className="col-md-6"> 
                        <input
                            type="text"
                            name="blood"
                            id="blood"
                            value={blood}
                            onChange={(e) =>
                                setBlood(e.target.value)
                            }
                            placeholder="Enter Blood Group"
                            required
                        />
                        </div>
                        </div> 
                      
                             </div>                        
                             
                        </div>
                        <div className="row spacing">
                        
                        <div className="col-md-4">
                        <div className="row">
                        <div className="col-md-6"><label htmlFor="employeename">Total Years of Experience</label></div>
                        <div className="col-md-6"> 
                        <input
                            type="text"
                            name="prexp"
                            id="prexp"
                            value={persexp}
                            onChange={(e) =>
                                setPersexp(e.target.value)
                            }
                            placeholder="Enter Previous Experience"
                            required
                        />
                        </div>
                        </div>
                        </div>
                        <div className="col-md-4">
                        <div className="row">
                        <div className="col-md-6">
                        <label htmlFor="birthday">Aadhar Number</label></div>
                        <div className="col-md-6">
                        <input
                            type="number"
                            name="emnumber"
                            id="emnumber"
                            value={aadharcard}
                            onChange={(e) =>
                                setAadharcard(e.target.value)
                            }
                            placeholder="Enter Aadhar Number"
                            required
                        />
                            </div>
                        </div>
                        </div>
                        
                                                
                        <div className="col-md-4">
                        <div className="row">
                        <div className="col-md-6"><label htmlFor="employeename">Pan Number </label></div>
                        <div className="col-md-6"> 
                        <input
                            type="text"
                            name="blood"
                            id="blood"
                            value={pan}
                            onChange={(e) =>
                                setPan(e.target.value)
                            }
                            placeholder="Enter Pan Number"
                            required
                        />
                        </div>
                        </div> 
                      
                             </div>     
                        </div>

                        <div className="row spacing">
                        <div className="col-md-4">
                        <div className="row">
                        <div className="col-md-6"><label htmlFor="employeename">Monthly Gross </label></div>
                        <div className="col-md-6">
                        <input
                            type="text"
                            name="blood"
                            id="blood"
                            value={monthlygrossdata}
                            onChange={(e) =>
                                setMonthlygrossdata(e.target.value)
                            }
                            placeholder="Enter Monthly gross"
                            required
                        />
                        </div>
                        </div>
                        </div>
                        <div className="col-md-6">
                        <div className="row">
                        <div className="col-md-4"><label htmlFor="employeename">Address</label></div>
                        <div className="col-md-8"> 
                        <input
                            type="text"
                            name="prexp"
                            id="prexp"
                            value={address}
                            onChange={(e) =>
                                setAddress(e.target.value)
                            }
                            placeholder="Enter Address"
                            required
                        />
                        </div>
                        </div>
                        </div>
                        </div> 
                        <div className="upload-docs">
                        <h3>Upload Documents</h3>  
                        </div>

                        <div className="row spacing">
                        <div className="col-md-4">
                        <div className="row">
                        <div className="col-md-6"> <label for="myfile">Aadhar Card:</label></div>
                        <div className="col-md-6"> 
                        <input type="file" id="myfiles-adhar" accept="application/pdf" onChange={(event) => filechangefn(event.target.files[0] || null,"myfiles-adhar")} name="myfiles" />
                        </div>
                        </div>
                        </div>
                        <div className="col-md-4">
                        <div className="row">
                        <div className="col-md-6">
                        <label for="myfile">PAN:</label></div>
                        <div className="col-md-6">
                        <input type="file" id="myfile-pan" accept="application/pdf" onChange={(event) => filechangepanfn(event.target.files[0] || null,"myfile-pan")} name="myfile" />
                            </div>
                        </div>
                        </div>
                        <div className="col-md-4">
                        <div className="row">
                        <div className="col-md-6"><label for="myfile">NDA</label></div>
                        <div className="col-md-6"> 
                        <input type="file" id="myfile_nrd" accept="application/pdf" onChange={(event) => filechangendafn(event.target.files[0] || null,"myfile_nrd")} name="myfile" />
                        </div>
                        </div> 
                      
                             </div> 
                            <div className="col-md-4">
                                         
                        </div>                      
                             
                        </div>

                        <div className="row spacing">
                        {/* <div className="col-md-4">
                        <div className="row">
                        <div className="col-md-6"> <label for="myfile">Monthly Gross ( As per Payslip):</label></div>
                        <div className="col-md-6"> 
                        <input type="file" id="myfile_gross" accept="application/pdf" onChange={(event) => filechangegrossfn(event.target.files[0] || null,"myfile_gross")} name="myfile" />
                        </div>
                        </div>
                        </div> */}
                        <div className="col-md-4">
                        <div className="row">
                        <div className="col-md-6">
                        <label for="myfile">Last 3 months payslip
                        </label></div>
                        <div className="col-md-6">
                        <input type="file" id="myfile_ctc"   accept="application/pdf" onChange={(event) => filechangectcfn(event.target.files[0] || null,"myfile_ctc")} name="myfile" />
                            </div>
                        </div>
                        </div>
                        <div className="col-md-4">
                        <div className="row">
                        <div className="col-md-6"><label for="myfile">Offer Letter</label></div>
                        <div className="col-md-6"> 
                        <input type="file" id="myfile_offer"  accept="application/pdf" onChange={(event) => filechangeofferfn(event.target.files[0] || null,"myfile_offer")} name="myfile" />
                        </div>
                        </div> 
                      
                             </div> 
                            <div className="col-md-4">
                                         
                        </div>                      
                             
                        </div>
                        <div className="row">          
                        <Button
                            variant="primary"
                            className="btns bts-clear"
                            type="reset"
                            value="reset"
                            onClick={() => handleReset()}
                        >
                            Clear
                        </Button>   
                        <Button
                        variant="primary"
                        className="btns bts-submit"
                            type="submit"
                            value="Submit"
                            onClick={(e) => handleSubmit(e)}
                        >
                            Submit
                        </Button>
                        </div> 

                          
            
        </div>
        </div> 
            </div>
        
        </div>
    );
}


export default Landing;
